
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1302Dialog extends Serenity.EntityDialog<Report_1302Row, any> {
        protected getFormKey() { return Report_1302Form.formKey; }
        protected getIdProperty() { return Report_1302Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1302Row.localTextPrefix; }
        protected getNameProperty() { return Report_1302Row.nameProperty; }
        protected getService() { return Report_1302Service.baseUrl; }
        protected getDeletePermission() { return Report_1302Row.deletePermission; }
        protected getInsertPermission() { return Report_1302Row.insertPermission; }
        protected getUpdatePermission() { return Report_1302Row.updatePermission; }

        protected form = new Report_1302Form(this.idPrefix);

    }
}